import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { HotelQuoteResult, HotelDetailTypes } from '@sabstravtech/obtservices/base';
import { HotelTag, UserService } from '@sabstravtech/obtservices/angular';

import { LightningModalTypes } from '../../../../../core/classes/modal-types.enum';
import { LightningUserFavorurite } from '../../../../../core/classes/user-favourite.enum';
import { UnitType } from '../../../../../core/interfaces/hotel-search-form-configuration';

@Component({
  selector: 'app-hotel-info-dialog',
  templateUrl: './hotel-info-dialog.component.html',
  styleUrls: ['./hotel-info-dialog.component.scss'],
  standalone: false
})
export class HotelInfoDialogComponent implements OnInit {
  // Input
  @Input() public hotelDetail: HotelQuoteResult = null;
  @Input() public thumbUrl: string = null;
  @Input() public address: string = null;
  @Input() distanceUnit: string = null;

  public hotelFacilities: HotelTag[] = [];
  public roomFacilities: HotelTag[] = [];
  userDistanceUnit: string;
  hotelDetailTypes = HotelDetailTypes;

  constructor(
    public activeModal: NgbActiveModal,
    private userService: UserService
  ) {}

  ngOnInit() {
    if (this.hotelDetail) {
      this.hotelFacilities = this.hotelDetail.tags.filter(
        (tag: HotelTag) => tag.type === 'Hotel Facilities'
      );
      this.roomFacilities = this.hotelDetail.tags.filter(
        (tag: HotelTag) => tag.type === 'Room Facilities'
      );
    }

    const hotelDistanceUnitConfig: any = this.userService.getUserFavoriteObject(
      LightningUserFavorurite.distanceUnit
    );
    this.userDistanceUnit = hotelDistanceUnitConfig?.unit || UnitType.Miles;
  }
}

LightningModalTypes.HotelInfoDialogComponent.component = HotelInfoDialogComponent;
